import { fmtTimeIST } from "@/lib/dateRange";
import { cn } from "@/lib/utils";
import { Play, Square, PauseCircle, WifiOff, Wifi, LogIn, LogOut, AlertTriangle } from "lucide-react";

const META = {
  shift_start: { icon: Play, tone: "bg-sky-100 text-sky-700" },
  shift_end: { icon: Square, tone: "bg-slate-200 text-slate-700" },
  stop: { icon: PauseCircle, tone: "bg-violet-100 text-violet-700" },
  signal_lost: { icon: WifiOff, tone: "bg-rose-100 text-rose-700" },
  signal_restored: { icon: Wifi, tone: "bg-emerald-100 text-emerald-700" },
  checkin: { icon: LogIn, tone: "bg-teal/10 text-teal" },
  checkout: { icon: LogOut, tone: "bg-teal/10 text-teal" },
  stale: { icon: AlertTriangle, tone: "bg-amber-100 text-amber-700" },
};

export default function EventFeed({ events = [] }) {
  return (
    <div className="bg-white border border-slate-200/80 rounded-xl shadow-sm p-5" data-testid="work-event-feed">
      <h3 className="text-lg font-semibold text-slate-900 mb-4">Shift timeline</h3>
      {events.length === 0 ? <p className="text-sm text-slate-400">No events recorded for this day.</p> : (
        <ol className="space-y-3">
          {events.map((e, i) => {
            const m = META[e.type] || META.stop;
            return (
              <li key={`${e.type}-${e.at}-${i}`} className="flex items-start gap-3" data-testid={`work-event-${e.type}-${i}`}>
                <span className={cn("grid place-items-center h-8 w-8 rounded-lg shrink-0", m.tone)}><m.icon className="h-4 w-4" /></span>
                <div className="min-w-0 flex-1 flex items-start justify-between gap-3">
                  <span className="text-sm font-medium text-slate-700">{e.label}</span>
                  <span className="text-xs text-slate-400 shrink-0 tabular-nums">{fmtTimeIST(e.at)}</span>
                </div>
              </li>
            );
          })}
        </ol>
      )}
    </div>
  );
}
